export default {
  ADMIN: "admin",
  USER: "user",
  PODCAST: "editor",
  CONFERENCE: "conference",
  CHANNEL_ADMIN: "channel_admin",
  CHANNEL_CONTENT_EDITOR: "channel_content_editor"
};
